import APIService from '@/services/APIService.js'

export default {
  getRelatorio(id) {
    return APIService.apiCall().get(`/consultasCustomizadas/getConsultaCustomizada/${id}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/consultasCustomizadas/salvar/${postData.id}`,JSON.stringify(postData))
  }
}